import {connect} from 'react-redux'
import {userSelector} from 'data/redux/selectors/userSelector';
import {isLoadingSelector} from 'data/redux/selectors/guiSelector';
import CrispChat from 'gui/components/crispChat';

const mapStateToProps = (state) => {
  return {
    userDetails: userSelector(state) || {},
    loading: isLoadingSelector(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

const CrispChatContainer = connect(mapStateToProps, mapDispatchToProps)(CrispChat);

export default CrispChatContainer;
